export default "__VITE_ASSET__CKo1yYeo__"